import * as React from 'react'
function SvgChevronDoubleLeft(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20.982 7.616l.029.024.02.026a2.995 2.995 0 01-.26 3.944l-8.547 8.546 8.547 8.547a3.001 3.001 0 01.26 3.944l-.02.025-.03.025a2.995 2.995 0 01-3.948-.266l-10.15-10.15a2.999 2.999 0 010-4.25l10.15-10.15a3.006 3.006 0 013.95-.265zm13.333 0l.029.024.021.026a2.995 2.995 0 01-.26 3.944l-8.547 8.546 8.546 8.547a3.001 3.001 0 01.26 3.944l-.023.027-.026.023a2.995 2.995 0 01-3.949-.266l-10.15-10.15a2.999 2.999 0 010-4.25l10.15-10.15a3.006 3.006 0 013.95-.265z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChevronDoubleLeft
